import Paragraph from "@common/components/Paragraph/Paragraph";
import { vars } from "@common/styles";
import styled from "styled-components";

export const Pill = styled.button`
  border: 1px solid ${vars.colors.grey80};
  background: ${vars.colors.grey100};
  border-radius: 12px 12px 2px 12px;
  max-width: 12rem;
  outline: none;
  height: 2.4rem;
  padding: 0.2rem 0.6rem 0.4rem 0.6rem;
  margin-bottom: 0.4rem;

  :hover {
    border: 1px solid ${vars.colors.purple};
    background: ${vars.colors.blackDarker};
  }
`;

export const PillText = styled(Paragraph)`
  color: ${vars.colors.grey30};
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
`;

export const Button = styled.button`
  border: 1px solid ${vars.colors.grey80};
  background: ${vars.colors.grey100};
  border-radius: 2.4rem;
  outline: none;
  height: 2.4rem;
  width: 2.4rem;
  margin-right: 0.4rem;
  margin-bottom: 0.4rem;
  display: flex;
  align-items: center;
  justify-content: center;

  :hover {
    border: 1px solid ${vars.colors.purple};
    background: ${vars.colors.blackDarker};
  }
`;
